import React from 'react';
import HostPortalStore from './HostPortalStore';
import HostPortalActions from './HostPortalActions';
import Icon from 'svgIcon';
import MyParties from './MyPartyListContainer';
import PartyDetailsHeader from './PartyDetailsHeader';
import PartyDetailsTabContainer from './PartyDetailsTabContainer';

export default class PartyDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = HostPortalStore.getState();
		this.onChange = this.onChange.bind(this);
	}

	componentDidMount() {
		HostPortalStore.listen(this.onChange);
		if (this.props.eventCode)
			HostPortalActions.getHostEventDetails(this.props.eventCode);
	}

	componentWillUnmount() {
		HostPortalStore.unlisten(this.onChange);
	}

	onChange(state) {
		this.setState(state);
	}

	render() {
		if (this.state.selectedEventDetails == null) return null;
        return (
			<div id="partyDetailsSectionContainer" className="site-container icon_button_content animate-in">
				<div className="blurb text-center">
					<a href="javascript:void(0);" className="section-back-link" onClick={this.props.setView.bind(this, MyParties)}>&laquo; &nbsp;{this.props.resources["PWS.MyAccount.PartyDetailsBackToListButton"]}</a>
				</div>
				<PartyDetailsHeader {...this.props} {...this.state} />
				<div className="spacer12"></div>
				<PartyDetailsTabContainer {...this.props} {...this.state} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/PartyDetails.js